import React, { Fragment, useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Box,
  Stack,
  Grid,
  CircularProgress,
  FormControlLabel,
} from "@mui/material";
import HomeLayout from "../../asset/layout/HomeLayout";
import { Add } from "@mui/icons-material";
import { useSelector } from "react-redux";
import SearchBar from "../../components/mui/SearchBar";
import Paginations from "../../components/mui/Pagination";
import CustomButton from "../../components/mui/CustomButton";
import RModal from "../../components/mui/RModal";
import InputField1 from "../../components/mui/InputField1";
import BasicDatePicker from "../../components/mui/BasicDatePicker";
import { enqueueSnackbar } from "notistack";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import {
  addCoupon,
  deleteCoupon,
  getAllCoupons,
  updateCoupon,
} from "../../actions/couponAuth";
import { useDispatch } from "react-redux";
import {} from "../../utils/common";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import ResponsiveDatePickers from "../../components/mui/PichDate";
import IOSSwitch from "../../style/globalStyles";
const columns = [
  " Coupon Code",
  "Description ",
  "Remaining/Total",
  "Expiry Date",
  "Active",
  "Action",
];

export const GeneralCoupons = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [openSecondModal, setOpenSecondModal] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [couponName, setCouponName] = useState("");
  const [couponNameUp, setCouponNameUp] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [amount, setAmount] = useState("");
  const [amountUpdate, setAmountUpdate] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [minAmountUpdate, setMinAmountUpdate] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionUp, setDescriptionUp] = useState("");
  const [expiryDate, setExpiryDate] = useState(null);
  const [expiryDateUp, setExpiryDateUp] = useState(null);
  const [quantity, setQuantity] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [allDiscountCoupon, setAllDiscountCoupon] = useState(25);
  const [Id, setId] = useState("");
  const Navigate = useNavigate();
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [totalCoupons, setTotalCoupons] = useState(0);
  const [activeTab, setActiveTab] = useState("general");
  const [error, setError] = useState("");
  const [formValid, setFormValid] = useState(false);
  const [updateFormValid, setUpdateFormValid] = useState(false);
  const [startQuantity, setStartQuantity] = useState("");

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      Navigate("/");
    }
  }, []);
  const { user } = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const getData = () => {
    const filters = {};

    dispatch(
      getAllCoupons(
        filters,
        (data) => {
          const filteredCoupons = applyFilters(data.data.data.Coupons);
          setCoupons(filteredCoupons);
          setTotalCoupons(data.data.results);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      )
    );
  };

  const applyFilters = (couponsData) => {
    let filteredCoupons = couponsData;

    // Filter by search term (couponName and description)
    if (searchTerm) {
      filteredCoupons = filteredCoupons.filter((item) =>
        [item?.couponName, item?.description].some((field) =>
          field?.toLowerCase().includes(searchTerm?.toLowerCase())
        )
      );
    }

    // Filter by expiry date range
    if (selectedDateFrom || selectedDateTo) {
      filteredCoupons = filteredCoupons.filter((item) => {
        const expiryDate = new Date(item?.expiryDate);

        let isAfterStartDate = true;
        if (selectedDateFrom) {
          isAfterStartDate = expiryDate >= new Date(selectedDateFrom);
        }

        let isBeforeEndDate = true;
        if (selectedDateTo) {
          const endOfDay = new Date(selectedDateTo);
          endOfDay.setHours(23, 59, 59, 999); // Set time to end of the day
          isBeforeEndDate = expiryDate <= endOfDay;
        }

        return isAfterStartDate && isBeforeEndDate;
      });
    }

    // Filter out special coupons
    filteredCoupons = filteredCoupons.filter((item) => !item?.isSpecial);

    return filteredCoupons;
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, [countPerPage, currentPage, searchTerm, selectedDateFrom, selectedDateTo]);

  const userId = user.id;

  const handleOpen = (item) => {
    setId(item?._id);
    setCouponNameUp(item?.couponName);
    setDescriptionUp(item?.description);
    setExpiryDateUp(dayjs(item?.expiryDate));
    setStartQuantity(item?.startQuantity);
    setAmountUpdate(item?.amount);
    setMinAmountUpdate(item?.minAmount);
    setOpen(true);
  };

  const handleClose = () => {
    console.log("false");
    setOpen(false);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleOpenSecondModal = () => {
    setOpenSecondModal(true);
  };

  const handleCloseSecondModal = () => {
    setOpenSecondModal(false);
    setCouponName("");
    setAmount("");
    setMinAmount("");
    setDescription("");
    setExpiryDate(null);
    setQuantity("");
  };

  const handleUpdate = (event) => {
    event.preventDefault();
    setLoadingUpdate(true);

    if (!couponNameUp || !descriptionUp || !expiryDateUp) {
      enqueueSnackbar("Please fill all details", {
        variant: "warning",
      });
      setLoadingUpdate(false);
    } else if (expiryDateUp < new Date()) {
      enqueueSnackbar("Expiry date cannot be before today.", {
        variant: "error",
      });
      setLoadingUpdate(false);
    } else {
      let payload = {
        couponName: couponNameUp,
        description: descriptionUp,
        expiryDate: expiryDateUp,
        amount: amountUpdate,
        minAmount: minAmountUpdate,
        startQuantity: startQuantity,
      };
      dispatch(
        updateCoupon(
          userId,
          Id,
          payload,
          (data) => {
            enqueueSnackbar("data update successfully", {
              variant: "success",
            });
            getData();
            setCouponNameUp("");
            setDescriptionUp("");
            setExpiryDateUp("");
            setLoadingUpdate(false);
            handleClose();
          },
          (err) => {
            enqueueSnackbar("Error occured", {
              variant: "error",
            });
            setLoadingUpdate(false);
          }
        )
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoadingSubmit(true);

    if (
      !couponName ||
      !amount ||
      !expiryDate ||
      !quantity ||
      !minAmount ||
      !description
    ) {
      enqueueSnackbar("Please fill all details.", {
        variant: "error",
      });
      setLoadingSubmit(false);
    } else {
      let payload = {
        couponName: couponName,
        amount: amount,
        minAmount: minAmount,
        description: description,
        expiryDate: expiryDate,
        quantity: quantity,
      };
      dispatch(
        addCoupon(
          payload,
          (data) => {
            enqueueSnackbar("data submit", {
              variant: "success",
            });
            getData();
            setLoadingSubmit(false);
            setCouponName("");
            setAmount("");
            setMinAmount("");
            setDescription("");
            setExpiryDate("");
            setQuantity("");
            handleCloseSecondModal();
          },
          (err) => {
            enqueueSnackbar("Error occured", {
              variant: "error",
            });
            setLoadingSubmit(false);
          }
        )
      );
    }
  };

  const handleDelete = (id) => {
    dispatch(
      deleteCoupon(
        userId,
        id,
        {},
        (data) => {
          enqueueSnackbar("Delete Successfully", {
            variant: "success",
          });
          getData();
        },
        (err) => {
          enqueueSnackbar("Error Occured! Please try again", {
            variant: "error",
          });
        }
      )
    );
  };

  const handleDateChange = (date) => {
    setExpiryDate(date);
  };
  const handleDateChangeUp = (date) => {
    setExpiryDateUp(date);
  };
  useEffect(() => {
    if (parseFloat(minAmount) < parseFloat(amount)) {
      setError(
        "Minimum Amount to Apply should be greater than or equal to Amount"
      );
    } else {
      setError("");
    }
  }, [amount, minAmount]);
  useEffect(() => {
    if (parseFloat(minAmountUpdate) < parseFloat(amountUpdate)) {
      setError(
        "Minimum Amount to Apply should be greater than or equal to Amount"
      );
    } else {
      setError("");
    }
  }, [amountUpdate, minAmountUpdate]);
  const handleSearchClear = () => {
    setSearchTerm("");
    setSelectedDateFrom(null);
    setSelectedDateTo(null);
  };

  const paginatedData = coupons.slice(
    (currentPage - 1) * countPerPage,
    currentPage * countPerPage
  );
  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(coupons);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Coupons");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    saveAs(new Blob([excelBuffer]), "coupons.xlsx");
  };
  //  const handleChangeActive = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: type === 'checkbox' ? checked : value,
  //   }));
  // };
  const validateForm = () => {
    if (amount && quantity && minAmount && description && expiryDate) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  useEffect(() => {
    validateForm();
  }, [amount, quantity, minAmount, description, expiryDate]);
  const validateUpdateForm = () => {
    if (descriptionUp && expiryDateUp && amountUpdate && minAmountUpdate) {
      setUpdateFormValid(true);
    } else {
      setUpdateFormValid(false);
    }
  };

  const handleChangeActive = (event, id, newStatus) => {
    const payload = {
      isActive: newStatus,
    };

    dispatch(
      updateCoupon(
        userId,
        id,
        payload,
        (data) => {
          enqueueSnackbar("Status updated successfully", {
            variant: "success",
          });
          getData();
        },
        (err) => {
          enqueueSnackbar("Error occurred", {
            variant: "error",
          });
        }
      )
    );
  };

  useEffect(() => {
    validateUpdateForm();
  }, [description, expiryDate, amountUpdate, minAmountUpdate]);

  const resetForm = () => {
    setCouponName("");
    setAmount("");
    setMinAmount("");

    setExpiryDate(null);
    setQuantity("");
    setError("");
    setDescription("");
  };
  return (
    <Fragment>
      <Stack alignItems="center" direction={"row"} mb={3}>
        <Typography
          variant="h4"
          my={3}
          flexGrow={1}
          fontSize={{ xl: "22px", sm: "1rem", xs: "1rem" }}
        ></Typography>
        <Box pr={2}>
          {" "}
          <CustomButton
            variant="contained"
            // onClick={handleExport}
            fontSize={{ xl: "1rem", sm: ".7rem", xs: ".7rem" }}
          >
            Export Coupons
          </CustomButton>
        </Box>
        <CustomButton
          variant="contained"
          onClick={handleOpenSecondModal}
          fontSize={{ xl: "1rem", sm: ".7rem", xs: ".7rem" }}
        >
          {" "}
          <Add sx={{ mr: { xl: 1, sm: 0.2 } }} />
          Add Coupon
        </CustomButton>
      </Stack>
      <Box>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Grid item xs={4}>
            <SearchBar onSearch={handleSearch} searchTerm={searchTerm} />
          </Grid>

          <Grid item md={3} xs={12}>
            <ResponsiveDatePickers
              selectedDate={selectedDateFrom}
              setSelectedDate={setSelectedDateFrom}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <ResponsiveDatePickers
              selectedDate={selectedDateTo}
              setSelectedDate={setSelectedDateTo}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            {" "}
            <CustomButton
              variant="contained"
              onClick={handleSearchClear}
              width={"100%"}
              height={"2.5rem"}
            >
              clear
            </CustomButton>
          </Grid>
        </Grid>
      </Box>
      {loading ? (
        <Box align="center" my={5}>
          <CircularProgress size={24} />
        </Box>
      ) : paginatedData.length > 0 ? (
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "25px",
            my: 3,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#11409B",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              sx={{
                whiteSpace: "nowrap",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              {coupons.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    {row?.couponName}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    {row?.description}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    {row?.currentQuantity} /{row?.startQuantity}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    {row?.expiryDate
                      ? dayjs(row.expiryDate).format("MM-DD-YYYY ")
                      : ""}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <FormControlLabel
                      style={{
                        padding: "1%",
                      }}
                      control={
                        <IOSSwitch
                          checked={row?.isActive}
                          onChange={(e) =>
                            handleChangeActive(e, row._id, !row.isActive)
                          }
                          // name="isActive"
                        />
                      }
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <IconButton onClick={() => handleOpen(row)}>
                      <img src="/liEdit.svg" alt="liEdit" />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(row?._id)}>
                      <img src="/liDelet.svg" alt="liDelet" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" sx={{ textAlign: "center", my: 3 }}>
          No results found.
        </Typography>
      )}

      {/* Pagination */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography>
            {(currentPage - 1) * countPerPage + 1} -{" "}
            {Math.min(currentPage * countPerPage, coupons.length)} of{" "}
            {coupons.length}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography>Rows per page:</Typography>
          <select
            style={{
              marginTop: "-5px",
              background: "transparent",
              border: "none",
            }}
            value={countPerPage}
            onChange={(e) => setCountPerPage(e.target.value)}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
          </select>
          <Box sx={{ ml: 2 }}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <IconButton
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1 || countPerPage > coupons.length}
                sx={{
                  border: "1px solid",
                  borderRadius: "10px",
                  borderColor: "mute.main",
                  bgcolor: "white.main",
                  boxShadow: "2px 2px 0px #999",
                  background: "#fff",
                }}
              >
                <KeyboardArrowLeftIcon
                  sx={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color:
                      currentPage === 1 || countPerPage > coupons.length
                        ? "#999"
                        : "#000",
                  }}
                />
              </IconButton>
              <Typography variant="text" component="span">
                {currentPage}/{Math.ceil(coupons.length / countPerPage)}
              </Typography>
              <IconButton
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={
                  countPerPage > coupons.length ||
                  currentPage === Math.ceil(coupons.length / countPerPage)
                }
                sx={{
                  border: "1px solid",
                  borderRadius: "10px",
                  borderColor: "mute.main",
                  bgcolor: "white.main",
                  boxShadow: "2px 2px 0px #999",
                  background: "#fff",
                }}
              >
                <KeyboardArrowRightIcon
                  sx={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                />
              </IconButton>
            </Stack>
          </Box>
        </Box>
      </Box>
      {open && (
        <RModal
          open={open}
          handleClose={handleClose}
          width={"80%"}
          height={{ xl: "70%", md: "80%", sm: "80%", xs: "80%" }}
        >
          <form onSubmit={handleUpdate}>
            <Typography variant="h4">Edit Coupon</Typography>

            <Grid container spacing={{ xl: 1, sm: 0, xs: 0 }}>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Coupon Code"}
                  placeholder={"Enter Coupon Code"}
                  spanP={true}
                  value={couponNameUp}
                  onChange={(e) => setCouponNameUp(e.target.value)}
                  required
                  maxLength={20}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Description"}
                  placeholder={"Enter Description"}
                  spanP={true}
                  value={descriptionUp}
                  onChange={(e) => setDescriptionUp(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <Typography mt={2}>
                  Expiry date <span style={{ color: "red" }}>*</span>
                </Typography>
                <BasicDatePicker
                  width={{ xl: "100%", xs: "100%" }}
                  required
                  onChange={handleDateChangeUp}
                  label="Expiry Date"
                  value={expiryDateUp}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={" Quantity"}
                  placeholder={"Enter Quantity"}
                  spanP={true}
                  value={startQuantity}
                  onChange={(e) => setStartQuantity(e.target.value)}
                  required
                  type="number"
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Amount"}
                  type="number"
                  placeholder={"Enter Amount"}
                  spanP={true}
                  value={amountUpdate}
                  onChange={(e) => setAmountUpdate(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  type="number"
                  label={"Minimum Amount To Apply "}
                  placeholder={"Enter Minimum Amount "}
                  spanP={true}
                  value={minAmountUpdate}
                  onChange={(e) => setMinAmountUpdate(e.target.value)}
                  required
                />{" "}
                {error && (
                  <Typography color="red" variant="body2">
                    {error}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Stack
              direction={"row"}
              spacing={{ xl: 6, md: 6, sm: 1, xs: 1 }}
              mt={4}
            >
              {" "}
              <CustomButton
                variant="contained"
                width={{
                  xl: "25vh",
                  md: "50%",
                  sm: "50%",
                  xs: "60%",
                }}
                height={"3rem"}
                type="submit"
                disabled={!updateFormValid || loadingUpdate}
              >
                {loadingUpdate ? (
                  <CircularProgress size={24} />
                ) : (
                  "Update Coupon"
                )}
              </CustomButton>
              {/* <CustomButton
                variant='outlined'
                width={{ xl: '20vh', md: '50%', sm: '50%', xs: '40%' }}
                height={'3rem'}
                type='reset'
              >
                Reset
              </CustomButton> */}
            </Stack>
          </form>
        </RModal>
      )}
      {openSecondModal && (
        <RModal
          open={openSecondModal}
          handleClose={handleCloseSecondModal}
          width={"80%"}
          height={{ xl: "70%", md: "80%", sm: "80%", xs: "80%" }}
        >
          <form onSubmit={handleSubmit}>
            <Typography variant="h4">Add Coupon</Typography>

            <Grid container spacing={{ xl: 1, sm: 0, xs: 0 }}>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Coupon Code"}
                  value={couponName}
                  placeholder={"Enter Coupon Code"}
                  spanP={true}
                  onChange={(e) => setCouponName(e.target.value)}
                  required
                  maxLength={20}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Amount"}
                  type="number"
                  placeholder={"Enter Amount"}
                  spanP={true}
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <Typography mt={2}>
                  Expiry date <span style={{ color: "red" }}>*</span>
                </Typography>
                <BasicDatePicker
                  width={{ xl: "100%", xs: "100%" }}
                  required
                  value={expiryDate}
                  onChange={handleDateChange}
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={" Quantity "}
                  placeholder={"Enter Coupon Quantity "}
                  type="number"
                  spanP={true}
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  type="number"
                  label={"Minimum Amount To Apply "}
                  placeholder={"Enter Minimum Amount "}
                  spanP={true}
                  value={minAmount}
                  onChange={(e) => setMinAmount(e.target.value)}
                  required
                />{" "}
                {error && (
                  <Typography color="red" variant="body2">
                    {error}
                  </Typography>
                )}
              </Grid>
              <Grid item xl={6} xs={12} sm={12}>
                <InputField1
                  placeholderColor=" #8D98AA"
                  label={"Description"}
                  placeholder={"Enter Description"}
                  spanP={true}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                  value={description}
                />
              </Grid>
            </Grid>
            <Stack
              direction={"row"}
              spacing={{ xl: 6, md: 6, sm: 1, xs: 1 }}
              mt={4}
            >
              {" "}
              <CustomButton
                variant="contained"
                width={{
                  xl: "25vh",
                  md: "50%",
                  sm: "50%",
                  xs: "60%",
                }}
                height={"3rem"}
                type="submit"
                disabled={!formValid || loadingSubmit || error}
              >
                {loadingSubmit ? <CircularProgress size={24} /> : "Add Coupon"}
              </CustomButton>
              <CustomButton
                variant="outlined"
                width={{
                  xl: "25vh",
                  md: "50%",
                  sm: "50%",
                  xs: "40%",
                }}
                height={"3rem"}
                type="button"
                onClick={resetForm}
              >
                Reset
              </CustomButton>
            </Stack>
          </form>
        </RModal>
      )}
    </Fragment>
  );
};
